import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { filter, Subject, takeUntil } from "rxjs";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { CartService } from "src/app/core/services/cart-service";
import { PedidoService } from "src/app/core/services/pedido-service";
import { ProductService } from "src/app/core/services/product-service";
import { SecurityService } from "src/app/core/services/security-service";
import { getOrderItemFromProduct } from "../shared/function";
import { ProductImageComponent } from "../product-image/product-image.component";
import { ProductQuantityInputComponent } from "../product-quantity-input/product-quantity-input.component";
import { ToastrService } from "ngx-toastr";
import { ConfiguracoesMisc } from "src/app/core/entities/configuracoesMisc";
import { CorteService } from "src/app/modules/product/services/corte.service";

@Component({
  selector: "app-catalog-item",
  templateUrl: "./catalog-item.component.html",
  styleUrls: ["./catalog-item.component.css"],
})
export class CatalogItemComponent implements OnInit, OnDestroy {
  MISC: ConfiguracoesMisc;
  @Input()
  public product: any;

  @Input()
  public produtoColXL;

  @Input()
  public produtoHeight;

  @Input()
  public produtoDescrHeight;

  @Input()
  public produtoDescrFontSize;

  @Input()
  public produtoIndispFontSize;

  @Input()
  public produtoDescrLen;

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild("productImage", { read: ProductImageComponent, static: true })
  public productImage!: ProductImageComponent;

  @ViewChild("productQtyInput")
  public productQtyInput?: ProductQuantityInputComponent;

  /** Total do produto no pedido (selo na foto); atualizado pelo pedido sem novo GET no catálogo. */
  public quantidadeCarrinho = 0;

  private destroy$ = new Subject<void>();

  public showStock: boolean;
  public userLogged: boolean = false;
  public validaEstoque: boolean;
  public pedido: any;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public SITE: ConfiguracoesSite;
  public mostraPreco = false;
  public stock: string;
  public config: ConfiguracoesMisc;
  constructor(
    public productService: ProductService,
    public securityService: SecurityService,
    public toastService: ToastrService,
    public pedidoService: PedidoService,
    public cartService: CartService,
    private corteService: CorteService
  ) {
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.SITE = Configuracoes.SITE;
    this.config = Configuracoes.MISC;

    this.pedido = this.pedidoService.pedido;
    if (!this.securityService.hasToken() && !this.SITE.mostraPrecoLoginAtivo)
      this.mostraPreco = true;
    if (
      this.securityService.hasToken() &&
      (!this.SITE.mostraPrecoPedidoSelecionado || this.pedido)
    ) {
      this.mostraPreco = true;
    }

    if (this.securityService.hasToken()) {
      this.userLogged = true;
    }
  }

  ngOnInit() {
    if (this.SITE.quantidadeMaximaGrade == false) {
      this.stock = `${this.product.estoque}`;
    } else if (this.product.estoque > this.SITE.quantidadeMaximaGrade) {
      this.stock = `+${this.SITE.quantidadeMaximaGrade}`;
    } else {
      this.stock = `${this.product.estoque}`;
    }

    if (this.pedido) {
      this.validaEstoque = this.pedido.tipo.validaEstoque;
    }
    // } else {
    this.showStock = this.SITE.mostraEstoqueDigitacao;
    // }

    this.refreshQuantidadeCarrinho();
    this.pedidoService.pedido$
      .pipe(
        takeUntil(this.destroy$),
        filter((p) => p != null)
      )
      .subscribe(() => this.refreshQuantidadeCarrinho());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private refreshQuantidadeCarrinho(): void {
    if (!this.product?.id || !this.pedidoService.pedido?.itens) {
      this.quantidadeCarrinho = 0;
      return;
    }
    this.quantidadeCarrinho = this.productService.getQuantityByProductId(
      this.product.id
    );

    // Para modo corte:
    // - badge `product-quantity` deve mostrar o peso total
    // - input readonly deve mostrar o total ajustado (com sobra) = `item.quantidade` (totalFinal)
    if (this.corteService.deveUsarPaginaCorte(this.product, false)) {
      const peso = this.productService.getPesoTotalCorteByProductId(this.product.id);
      if (peso > 0) {
        this.quantidadeCarrinho = peso;
      }

      const totalFinal = this.productService.getQuantityByProductId(this.product.id);
      if (totalFinal > 0) {
        this.product.quantidade = totalFinal;
        setTimeout(() => this.productQtyInput?.updateQuantity(totalFinal));
      }
    }
  }

  private resetQuantidadeInputAposIncluir(): void {
    const p = this.product;
    let next = 1;
    if (p.multiplo != null && p.multiplo !== undefined) {
      next = Number(p.multiplo) || 1;
    } else if (p.quantidade_minima) {
      next = Number(p.quantidade_minima) || 1;
    }
    p.quantidade = next;
    setTimeout(() => this.productQtyInput?.updateQuantity(next));
  }

  public addCart(quantity: number) {
    if (this.product.sku) {
      const tax = this.product.imposto;
      const price = this.product.precopromocional
        ? this.product.precopromocional
        : this.product.preco;

      let taxValue = null;
      let taxCalc = {};

      if (tax) {
        taxCalc = this.productService.calculaImposto(
          price,
          tax.ipi,
          tax.alicms,
          tax.substicms,
          tax.alicmsorigem,
          tax.fcpSt
        );
        taxValue = this.productService.calculaValorImposto(
          price,
          tax.ipi,
          tax.alicms,
          tax.substicms,
          tax.alicmsorigem,
          tax.fcpSt
        );
      }
      const item = getOrderItemFromProduct(
        this.product,
        taxCalc,
        tax,
        taxValue,
        this.pedidoService.pedido.clientes[0].cliente.id,
        quantity,
        quantity * price
      );
      this.pedidoService.setCartItemsSku(
        [item],
        (res) => this.doOnSuccess(res, [item]),
        (res) => this.doOnError(res)
      );
    }
  }

  public doOnSuccess(res, items) {
    // let response = {...res, itens: res.itens.map((r: any)=> ({...r, produtoreferencia: r.produtoReferencia}))}
    this.cartService.addItems(items);
    this.pedidoService.select(res);
    this.refreshQuantidadeCarrinho();
    this.resetQuantidadeInputAposIncluir();
  }

  public doOnError(res) {
    this.refreshQuantidadeCarrinho();
    this.resetQuantidadeInputAposIncluir();
    if (res.status === 400) {
      this.toastService.error(res.error.detail, $localize`Produto`, {
        positionClass: "toast-bottom-left",
      });
      // window.location.reload();
    }
  }

  public getPrice() {
    let taxValue = 0;
    let tax: any = 0;
    if (!this.SITE.mostraprecosemimposto) {
      tax = this.product.imposto;
    }

    if (tax && !this.SITE.mostraprecosemimposto) {
      const price = this.product.precopromocional
        ? this.product.precopromocional
        : this.product.preco;
      taxValue = this.productService.calculaValorImposto(
        price,
        tax.ipi,
        tax.alicms,
        tax.substicms,
        tax.alicmsorigem,
        tax.fcpSt
      );
    }

    return this.product.preco + taxValue;
  }

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    this.refreshQuantidadeCarrinho();
    this.productImage.updateQuantity(quantity);
    this.ngOnInit();
  }
}
